import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { ICredentials } from '../../models';
import { AuthRepositoryService } from '../../repositories';


@Injectable({ providedIn: 'root' })
export class CredentialsService {
    private authRepository = inject(AuthRepositoryService);


    public getCredentials(userId: string): Promise<ICredentials> {
        return firstValueFrom(this.authRepository.getCredentials(userId));
    }

    public resetPassword(userId: string): Promise<void> {
        return firstValueFrom(this.authRepository.resetPassword(userId));
    }
}
